
import LoginPage from "@/pages/LoginPage.vue";
import Thongkebenhnhan from "@/pages/Thongkebenhnhan.vue";

import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  components: {
    LoginPage,
    Thongkebenhnhan,
   // DanhSachDeTai,
  },
  setup(){
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    console.log("##########$$$$$$$$$$$$$$$ log 11111111");

    return {
      isLoggedIn
    }
  }
}
